import { render } from "./Ikp.vue?vue&type=template&id=6913e4da"
import script from "./Ikp.vue?vue&type=script&lang=js"
export * from "./Ikp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__